import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import AntDTable from '../Common/AntDTable/AntDTable';
import { SetView } from '../../Redux/action/visitorAction';
import { alignPropType } from 'react-bootstrap/esm/types';

const VisitorAntDTable = ({
  visitorReducer,
  SetView,
  currentPage,
  pageSize,
  onTableChange,
  onPageChange,
  openVisitorPopup, // new prop
}) => {
  const tableData = visitorReducer?.VisitorTableData?.data || [];
  const total = Number(visitorReducer?.VisitorTableData?.total) || 0;
  const loading = visitorReducer?.loader;

  const visitorStatus = [
    'Details pending',
    'Details uploaded',
    'Details approved',
    'Checked-in',
    'Details rejected',
    'Visit cancelled',
    'Checked-out',
  ];

  const columns = [
    {
      title: 'Name',
      key: 'name',
      sorter: true,
      render: (_, record) => `${record.fname} ${record.lname}`,
    },
    {
      title: 'Visitor Type',
      dataIndex: 'visitor_type',
      sorter: true,
      render: val => (val === 1 ? 'Walk-In' : 'Pre-Invite'),
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
    },
    {
      title: 'Location',
      dataIndex: 'name',
    },
    {
      title: 'Host Name',
      render: (_, r) => `${r.hfirstname} ${r.hlastname}`,
    },
    {
      title: 'Host Email',
      dataIndex: 'hemail',
    },
    {
      title: 'In Time',
      dataIndex: 'in_time',
      sorter: true,
      render: val =>
        `${moment(val).format('DD-MM-YYYY')} ${moment(val).format('hh:mm:ss')}`,
    },
    {
      title: 'Current Status',
      dataIndex: 'approve_by_client',
      render: (val, record) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span>{visitorStatus[val]}</span>
        </div>
      ),
    },
    {
      title: 'View',
      align: 'center',
      render: (val, record) => (
        <i
          className="bi bi-eye-fill"
          onClick={e => {
            e.stopPropagation(); // prevent row click
            openVisitorPopup(record); // open popup
          }}
          title="View Details"
          role="button"
        />
      ),
    },
  ];

  const handleRowClick = record => {
    SetView({ visitid: record.id });
  };

  return (
    <AntDTable
      columns={columns}
      dataSource={tableData}
      loading={loading}
      size='small'
      currentPage={currentPage}
      pageSize={pageSize}
      totalRecords={total}
      onChange={onTableChange}
      onPageChange={onPageChange}
      onRowClick={handleRowClick}
      clientSideSorting={false} // server side
    />
  );
};

const mapStateToProps = state => ({
  visitorReducer: state.visitorReducer,
});

export default connect(
  mapStateToProps,
  { SetView },
)(VisitorAntDTable);
